export default "/_next/static/chunks/fonts/WhitneySSm-Medium-Pro_Web-68a514839ea854e8e178e22d58647ec7.woff";